import { Leaf, Sparkles, Home, Shirt, Wallet, GraduationCap, Clock, Users, Heart, Star, ShieldCheck, Truck, HeartHandshake, Gift, TrendingUp, Award, Zap, Smile } from "lucide-react";

export const CATEGORIES = [
  { value: "all", label: "All" },
  { value: "apparel", label: "Apparels" },
  { value: "beverage", label: "Dietary Supplements" },
];

// categories selectable in the admin product editor
export const PRODUCT_CATEGORIES = [
  { value: "apparel", label: "Apparels" },
  { value: "beverage", label: "Dietary Supplements" },
];

export const CATEGORY_BADGE = {
  apparel: "bg-[hsl(211_70%_92%)] text-[hsl(211_60%_28%)] border border-[hsl(211_40%_82%)]",
  beverage: "bg-[hsl(38_70%_92%)] text-[hsl(38_60%_28%)] border border-[hsl(38_40%_82%)]",
};

export const CATEGORY_LABEL = {
  apparel: "Apparels",
  beverage: "Dietary Supplements",
};

// Map string icon keys (stored in content) to lucide components.
export const ICON_MAP = {
  leaf: Leaf,
  sparkles: Sparkles,
  home: Home,
  shirt: Shirt,
  wallet: Wallet,
  cap: GraduationCap,
  clock: Clock,
  users: Users,
  heart: Heart,
  star: Star,
  shield: ShieldCheck,
  truck: Truck,
  handshake: HeartHandshake,
  gift: Gift,
  trending: TrendingUp,
  award: Award,
  zap: Zap,
  smile: Smile,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const getIcon = (key) => ICON_MAP[key] || Leaf;

// Full fallback content (mirrors backend DEFAULT_CONTENT). Used as the base
// for merging the fetched content, and as a safety net if the API is down.
export const FALLBACK_CONTENT = {
  brand: {
    brandName: "Ecentra",
    distributorName: "Sam C. Ortega",
    distributorPhoto: "/api/media/distributor-sam",
    role: "Independent Ecentra Distributor",
    tagline: "Wellness, Beauty & Home Essentials",
    location: "Makati City, Metro Manila",
    phone: "+63 917 894 1208",
    email: "samglobalbiz888@gmail.com",
    whatsapp: "https://wa.me/639178941208",
    messenger: "https://m.me/sam.ortega.96",
    facebook: "https://www.facebook.com/sam.ortega.96",
    instagram: "",
    currencySymbol: "\u20b1",
  },
  hero: {
    badge: "",
    headline: "Wellness, beauty at home essentials \u2014 para sa araw-araw mong rutin.",
    subhead: "Discover ang authentic na Ecentra products na sikat sa buong Pilipinas \u2014 at magsimula ng sarili mong negosyo by sharing kung ano ang love mo, kasama ang team na laging supportive sa'yo.",
    ctaShop: "Mag-shop Na",
    ctaJoin: "Join My Team",
    imageMain: "https://images.unsplash.com/photo-1772987714654-2df39af2c658?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageSecondary: "https://images.unsplash.com/photo-1746227638992-50b1e1e0d96b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    statValue: "16+",
    statLabel: "premium products",
    chips: [
      { label: "Authentic products" },
      { label: "Nationwide delivery" },
      { label: "Personal support" },
    ],
  },
  about: {
    eyebrow: "Bakit Ecentra",
    heading: "Premium products na talagang magugustuhan mo",
    body: "Pinagsama-sama ng Ecentra ang science-based na wellness, results-driven na beauty, at eco-friendly na home care \u2014 all sa isang trusted na linya. Bilang independent distributor, ang ibinabahagi ko lang ay yung talagang gamit at love ko.",
    image: "/api/media/about-composite",
    items: [
      { icon: "leaf", title: "Wellness na epektibo", desc: "Science-backed na supplements at drinks para sa tunay na sigla araw-araw." },
      { icon: "sparkles", title: "Beauty mula sa loob", desc: "Advanced peptide skincare para sa mas firm, mas maputi, at mas healthy na balat." },
      { icon: "home", title: "Mas malinis na tahanan", desc: "Concentrated at plant-based na eco cleaners na mild sa'yo at sa kalikasan." },
      { icon: "shirt", title: "Graphene comfort", desc: "enerG+ apparel na may graphene technology para sa init at dagdag-enerhiya araw-araw." },
    ],
  },
  products: {
    eyebrow: "Shop the Collection",
    heading: "Ang mga best-seller naming products",
    body: "I-tap ang kahit anong product para makita ang details, tapos mag-send ng inquiry \u2014 ako mismo ang magko-confirm ng presyo, stock, at delivery.",
    priceLabel: "Promo Price",
    promoNote: "Promotional price \u2014 mag-iiba ang presyo anytime soon. I-order na habang promo pa!",
    disclaimer: "Hindi gamot. Results may vary.",
  },
  productMenu: {
    eyebrow: "Product menu",
    heading: "Alamin nang husto ang bawat product",
    body: "I-tap ang bawat product para makita ang buong details \u2014 features, advantages, at ang science sa likod ng bawat infused element.",
  },
  opportunity: {
    eyebrow: "Ang opportunity",
    heading: "Bumuo ng negosyong ipagmamalaki mo \u2014 may team na kasama mo",
    body: "Gusto mo man ng dagdag-kita o full-time na pagbabago, ang pagsali sa aking Ecentra team ay may tunay na mentorship, proven systems, at mga product na talagang inuulit-ulit bilhin ng mga tao. Walang hype \u2014 puro honest work at steady na paglago.",
    benefits: [
      { icon: "wallet", title: "Flexible na kita", desc: "Kumita mula sa product sales at palakihin ang rewards habang lumalaki ang team mo \u2014 sa sarili mong pace.", image: "/api/media/opp-flexible-income" },
      { icon: "cap", title: "Tunay na training", desc: "Step-by-step na mentorship, product knowledge, at selling skills \u2014 kahit baguhan ka pa.", image: "/api/media/opp-real-training" },
      { icon: "users", title: "Supportive na team", desc: "Sumali sa komunidad na nag-cecelebrate ng panalo mo at tumutulong sa mahihirap na parte.", image: "/api/media/opp-supportive-team" },
      { icon: "clock", title: "Work kahit saan", desc: "Buuin ang negosyo gamit ang phone mo, kasabay ng pamilya at schedule mo.", image: "/api/media/opp-work-anywhere" },
    ],
    stepsTitle: "Paano ito gumagana",
    steps: [
      { step: "01", title: "Mag-apply", desc: "Punan ang maikling form sa baba at sabihin ang goals mo." },
      { step: "02", title: "Ma-onboard", desc: "Kokontakin ka namin, sasagutin ang tanong mo, at ise-set up ang starter kit mo." },
      { step: "03", title: "Magsimulang kumita", desc: "I-share ang mga product na love mo, sundin ang system, at palakihin ang team mo." },
    ],
    formHeading: "Join My Team",
    formSub: "Mag-apply nang wala pang isang minuto \u2014 walang obligasyon.",
    successHeading: "Kasama ka na!",
    successBody: "Salamat sa pag-apply na sumali sa team. Ako mismo ang babalik sa'yo para sa next steps at sasagutin ang mga tanong mo.",
  },
  // Personal letter from the distributor, shown beside the Join My Team form. photo blank = brand.distributorPhoto
  aboutMe: {
    enabled: true,
    eyebrow: "Kilalanin ang leader mo",
    greeting: "Hi, ako si Sam.",
    tagline: "Another Run \u2014 A Remarkable Ecentra Journey",
    paragraphs: [
      "Tatlumpung taon ang humubog sa akin \u2014 bilang corporate management strategist at bilang network leader at builder. Parehong sombrero ang nasuot ko, at bihira 'yan sa industriyang ito: alam ko kung paano mag-plano na parang boardroom, at kung paano mag-build ng team na may puso.",
      "Ngayon, nasa \u201cAnother Run\u201d ako \u2014 a remarkable Ecentra journey. Binubuo ko ang isang successful, highly spirited, at high-performing sales organization sa pamamagitan ng Ecentra, isang network marketing company na base sa Malaysia.",
      "Kung handa kang matuto ng tamang sistema, ma-coach nang seryoso, at lumago kasama ng team na may disiplina at saya \u2014 may puwesto ka rito. Hindi kita iiwan sa ere; sabay tayong tatakbo.",
    ],
    roles: ["Corporate Strategist", "Network Leader & Builder", "Trainer & Coach", "System Architect"],
    signatureName: "Sam C. Ortega",
    signatureRole: "Independent Ecentra Distributor \u00b7 Makati City",
    ctaLabel: "Sali sa team ko",
    photo: "",
  },
  testimonials: {
    eyebrow: "Loved by real people",
    heading: "Stories mula sa customers at team members",
    items: [
      { name: "Maria Santos", role: "Loyal na customer \u2022 Quezon City", quote: "Sobrang na-brighten ng The Peptide serum ang skin ko in a few weeks. Inoorder ko na ngayon para sa buong pamilya.", avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=faces&fit=crop&w=200&h=200&q=80" },
      { name: "Jenny Reyes", role: "Team member \u2022 Cebu", quote: "Nagsimula ako part-time habang inaalagaan ang mga anak ko. Ang training at mentorship ang malaking pagkakaiba.", avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=faces&fit=crop&w=200&h=200&q=80" },
      { name: "Paolo Cruz", role: "Customer \u2022 Davao", quote: "Inayos ng Probiotics Plus ang digestion ko, at ang bango ng ecoV cleaners. Mabilis at friendly din ang service.", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=faces&fit=crop&w=200&h=200&q=80" },
    ],
  },
  faq: {
    eyebrow: "Dapat mong malaman",
    heading: "Mga madalas na tanong",
    items: [
      { q: "Paano ako mag-order ng product?", a: "I-browse ang mga product sa taas, i-tap ang Order / Inquire sa kahit anong item, at i-send ang details mo. Ico-confirm namin agad ang availability, total price, at delivery." },
      { q: "Nagde-deliver ba kayo nationwide?", a: "Oo \u2014 nag-aayos kami ng delivery sa buong Pilipinas. Ang shipping options at fees ay ico-confirm namin pagkatapos ng inquiry mo." },
      { q: "Paano sumali sa team at anong support ang makukuha ko?", a: "Punan ang \u201cJoin My Team\u201d form. Kapag nag-apply ka, ako mismo ang mag-oonboard sa'yo \u2014 with product training, starter kit, at proven system para makapagsimula ka nang may kumpiyansa." },
      { q: "May starter kit ba?", a: "Oo. Ang bagong members ay may starter kit na may best-selling products at marketing tools. Ipapaliwanag namin ang current options during onboarding." },
      { q: "Paano gumagana ang commissions at rewards?", a: "Kumikita ka mula sa sarili mong product sales, at may dagdag na rewards habang lumalaki ang team mo. Everything is clear \u2014 ipapaliwanag namin bago ka mag-commit." },
    ],
  },
  contact: {
    eyebrow: "Mag-usap tayo",
    heading: "May tanong? Nandito ako para tumulong",
    body: "Gusto mo man mag-try ng product o mag-explore ng negosyo, mag-message ka lang directly \u2014 ako mismo ang sasagot.",
  },
  footer: {
    tagline: "Premium na wellness, beauty, at home essentials \u2014 plus tunay na business opportunity sa Pilipinas.",
    disclaimer: "Hindi ito ang corporate HQ website. Results may vary. Hindi gamot. Hindi panggamot.",
  },
  promo: {
    enabled: true,
    text: "Bagong member promo \u2014 sumali ngayon at makakuha ng starter discount!",
    linkLabel: "Alamin",
    linkTarget: "join",
  },
  payment: {
    gcashEnabled: true,
    gcashName: "",
    gcashNumber: "0917 894 1208",
    gcashQr: "",
    instructions: "I-send ang EXACT na amount sa GCash number/QR sa itaas, tapos ilagay ang GCash Reference No. sa baba. Ico-confirm namin ang order mo kapag na-verify na ang bayad.",
  },
};
